import React from "react";
import { Helmet } from "react-helmet";
import HealthPackages from "../../healthpackages/HealthPackages";

const HealthPackagesPage = () => {
  return (
    <>
      <Helmet>
        <title>Health Packages | Columbiaa Hospital Best Multi-Speciality Hospital Kasturi Nagar Bangalore</title>
        <meta name="description" content="Columbiaa Hospital offers affordable preventive health packages and executive wellness checkup packages in Kasturi Nagar, Bangalore. Complete health screening, full body checkup, cardiac care, diabetes screening, and more. Book your health package today." />
        <meta name="keywords" content="health packages, Columbiaa Hospital, preventive health checkup, executive wellness package, full body checkup, health screening, medical checkup, health checkup packages, preventive healthcare, wellness packages, hospital in Kasturi Nagar, hospital in Bangalore, best hospital, multi-speciality hospital, health checkup Bangalore, medical checkup package, cardiac health package, diabetes screening, thyroid test, kidney function test, liver function test, complete blood count, affordable health packages, yearly health checkup, executive health checkup, corporate health packages, family health packages, health packages near me" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Health Packages | Columbiaa Hospital Best Multi-Speciality Hospital Kasturi Nagar Bangalore" />
        <meta property="og:description" content="Discover affordable preventive health and executive wellness packages at Columbiaa Hospital, Kasturi Nagar, Bangalore. Book comprehensive health checkup packages today." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/health-packages" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/health-packages" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>

      <section
        className="page-title py-5"
        style={{
          backgroundImage: "url(assets/images/background/page-title-2.jpg)",
          overflowX: "hidden",
        }}
        aria-label="Health Packages - Columbiaa Hospital, Kasturi Nagar, Bangalore"
      >
        <div
          className="pattern-layer"
          style={{
            backgroundImage: "url(assets/images/shape/pattern-35.png)",
          }}
          aria-hidden="true"
        ></div>
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-12 col-md-10 text-center"
              data-aos="fade-right"
            >
              <div className="title-box my-4 my-md-0">
                <h1 className="display-4" aria-label="Our Health Packages">Our Health Packages</h1>
                <p className="lead" aria-label="Columbiaa Hospital - Your Health Care Partner">
                  Columbiaa Hospital – Your Health Care Partner in Kasturi Nagar, Bangalore.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HealthPackages/>
    </>
  );
};

export default HealthPackagesPage;
